import { Directive, inject, input } from '@angular/core';
import { AutocompleteOption } from '@shared/components/autocomplete/autocomplete.interfaces';
import { UserSearchStateService } from '../services/user-search-state.service';
import { DEFAULT_USA_PHONE_PREFIX } from '@app/core/constants/countries-phone-prefix';
import { FormGroupDirective } from '@angular/forms';

@Directive({
  selector: '[appHandleAutocompleteOptionClick]',
  host: { '(optionSelected)': 'handleAutoCompleteOptionClick($event)' },
})
export class HandleAutocompleteOptionClickDirective {
  public searchType = input.required<'firstName' | 'email'>();

  private readonly _fgd = inject(FormGroupDirective);
  private readonly _userSearchStateService = inject(UserSearchStateService);

  private readonly _searchedUsersByEmail =
    this._userSearchStateService.searchedUsersByEmail;
  private readonly _searchedUsersByName =
    this._userSearchStateService.searchedUsersByName;

  protected handleAutoCompleteOptionClick(event: Event): void {
    const option = event as unknown as AutocompleteOption;
    const searchType = this.searchType();
    const users =
      searchType === 'firstName'
        ? this._searchedUsersByName()
        : this._searchedUsersByEmail();

    const selectedUser = users.find((o) => String(o.id) === option.value);

    if (!selectedUser) return;

    this._fgd.form.patchValue({
      email: selectedUser?.email ?? '',
      firstName: selectedUser?.firstName,
      lastName: selectedUser?.lastName,
      middleName: selectedUser?.middleName ?? '',
      username: selectedUser?.username,
      phoneNumber: selectedUser?.phoneNumber ?? '',
      prefixPhone: selectedUser?.prefixPhone ?? DEFAULT_USA_PHONE_PREFIX,
      userId: selectedUser?.id,
    });

    this._fgd.form.get('email')?.disable();
    this._fgd.form.get('firstName')?.disable();
    this._fgd.form.get('lastName')?.disable();
    this._fgd.form.get('middleName')?.disable();
    this._fgd.form.get('username')?.disable();
    this._fgd.form.get('phoneNumber')?.disable();
    this._fgd.form.get('prefixPhone')?.disable();
  }
}
